import { SVGProps } from 'react';

const HoldingsConvertIcon = ({
  className,
  style,
  width,
  height,
  fill,
}: SVGProps<SVGSVGElement>) => (
  <svg
    className={className}
    width={width || '16'}
    height={height || '16'}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-palette="HoldingsConvertIcon">
    <path
      style={style}
      d="M3.64265 2.95533C4.85236 1.90711 6.39998 1.3311 8.00065 1.33333C11.6827 1.33333 14.6673 4.318 14.6673 8C14.6673 9.424 14.2207 10.744 13.4607 11.8267L11.334 8H13.334C13.3341 6.95442 13.0268 5.93187 12.4504 5.05951C11.874 4.18714 11.0539 3.50344 10.0921 3.09342C9.13027 2.68339 8.06913 2.56514 7.04062 2.75335C6.01212 2.94156 5.06162 3.42793 4.30732 4.152L3.64265 2.95533ZM12.3587 13.0447C11.1489 14.0929 9.60133 14.6689 8.00065 14.6667C4.31865 14.6667 1.33398 11.682 1.33398 8C1.33398 6.576 1.78065 5.256 2.54065 4.17333L4.66732 8H2.66732C2.66723 9.04559 2.97449 10.0681 3.55088 10.9405C4.12726 11.8129 4.94736 12.4966 5.9092 12.9066C6.87103 13.3166 7.93218 13.4349 8.96068 13.2467C9.98919 13.0584 10.9397 12.5721 11.694 11.848L12.3587 13.0447Z"
      fill={fill || 'var(--brand-bg-primary)'}
      strokeWidth="0"
    />
  </svg>
);

export default HoldingsConvertIcon;
